import React from "react";
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import PropTypes from "prop-types";

function CheckboxComponent({ handleCheckboxEvent, name, checkState }) {
  return (
    <div>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleCheckboxEvent}
              name={name}
              checked={checkState}
            />
          }
        />
      </FormGroup>
    </div>
  );
}
CheckboxComponent.propTypes = {
  handleCheckboxEvent: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  checkState: PropTypes.bool.isRequired,
};

export default CheckboxComponent;
